import { render } from "./RegistrationSearchNPI.vue?vue&type=template&id=47e8a6bb&scoped=true&ts=true"
import script from "./RegistrationSearchNPI.vue?vue&type=script&lang=ts"
export * from "./RegistrationSearchNPI.vue?vue&type=script&lang=ts"

import "./RegistrationSearchNPI.vue?vue&type=style&index=0&id=47e8a6bb&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e8a6bb"]])

export default __exports__